import { format, addMinutes } from 'date-fns';
import React, { useEffect } from 'react';
import DatePicker from 'react-datepicker';
import { useSelector } from 'react-redux';
import { patchTodo } from 'redux/actions/leadsActions.js';
import selectors from '../selectors/selectors.js';
import setQuery from '../lib/setQuery.js';
import useBoundForm from '../hooks/useBoundForm.js';
import BoundFormGroup from './boundForm/BoundFormGroup.js';
import BoundButton from './boundForm/BoundButton.js';
import castDateStringAsUTC from '../lib/castDateStringAsUTC.js';
import LeadDataSectionHeading from '../screens/leadModal/leadData/LeadDataSectionHeading.js';
import { getPipelineLeadOptions } from 'lib/pipelineLeads/getPipelineLeadOptions';
import safariDate from 'lib/safariDate.js';

export const formatDateForDatabase = (date) => {
  let fixedDate = typeof date === 'string' ? date.replace(/-/g, '/') : date;
  const dt = new Date(fixedDate);
  return format(addMinutes(dt, dt.getTimezoneOffset()), "yyyy-MM-dd'T'HH:mm:ss'Z'");
};

const LeadDataTodoEditor = () => {
  const serviceProviderId = useSelector(selectors.serviceProviderId);
  const activeLead = useSelector(selectors.activeLead);
  const pipelines = useSelector(selectors.serviceProviderPipelines);
  const todoId = useSelector(selectors.todoId);

  const todoIds = ((activeLead || {}).todos || []).map((n) => n.id);
  const todoItems = useSelector(selectors.todosByIds(todoIds));
  const todoTypes = useSelector(selectors.todoTypes) || [];

  const todoItem = (todoItems || []).find((item) => item.id === todoId);
  const pipelineLeadOptions = getPipelineLeadOptions(pipelines, activeLead.pipeline_leads);
  const todoTypeOptions = todoTypes.map((n) => ({ value: n.id, label: n.type }));

  const form = useBoundForm({
    initialState: {
      target_datetime: castDateStringAsUTC(todoItem.target_datetime),
      description: todoItem.todo_description || '',
      type_id: todoItem.todo_type,
      pipeline_lead_id: todoItem.pipeline_lead_id ? todoItem.pipeline_lead_id : null,
      assignee_user_id: todoItem.assignee_user_id,
    },
  });

  const targetDatetime = safariDate(form.state.target_datetime);

  const handleSaveClick = () => {
    patchTodo({
      serviceProviderId,
      id: todoItem.id,
      description: form.state.description,
      typeId: form.state.type_id,
      pipelineLeadId: form.state.pipeline_lead_id || null,
      assigneeUserId: form.state.assignee_user_id,
      statusId: todoItem.todo_status,
      serviceLocationId: todoItem.service_location_id || null,
      leadId: todoItem.lead_id || null,
      targetDatetime: formatDateForDatabase(form.state.target_datetime),
      callback: () => {
        setQuery({ todoId: null });
      },
    });
  };

  const fields = [
    [{ id: 'assignee_user_id', placeholder: 'Assign User', options: 'user' }],
    [{ id: 'type_id', placeholder: 'Assign Type', options: todoTypeOptions }],
    [{ id: 'pipeline_lead_id', placeholder: 'Assign To Pipeline Lead', nullable: true, nullableLabel: "None", options: pipelineLeadOptions }],
    [{ id: 'description', placeholder: 'Add Description', type: 'textarea' }]
  ];

  useEffect(() => {
    form.reset();
  }, [todoId]);

  return (
    <div className={'lead-data-section todo-section'}>
      <LeadDataSectionHeading icon={'Todos'} back={'Todos'} onBackClick={() => setQuery({ todoId: null })}>
        Edit Todo
      </LeadDataSectionHeading>
      <div className="lead-data-todo-editor">
        <div className={'datepicker-container'}>
          <label className="form-label due-date">Due Date</label>
          <DatePicker selected={form.state.target_datetime ? new Date(targetDatetime) : new Date()} onChange={(date) => form.set('target_datetime', new Date(date))} showTimeSelect timeIntervals={15} timeCaption="time" dateFormat="MMMM d, yyyy h:mm aa" className="fixed-width form-control" />
        </div>
        <BoundFormGroup formId={form.id} fields={fields} />
      </div>
      <div className="button-row">
        <BoundButton type={'submit'} formId={form.id} label={'Save'} onClick={(e) => handleSaveClick(e)} />
        <BoundButton type={'cancel'} formId={form.id} onClick={(e) => setQuery({ todoId: null })} />
      </div>
    </div>
  );
};

export default LeadDataTodoEditor;
